import { InjectionKey, Ref } from 'vue';

// This follows the recommendation for typing Provide/Inject: https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject
export const triggerHideTooltipKey = Symbol('triggerHideTooltipKey') as InjectionKey<Ref<number>>;
